import { render, staticRenderFns } from "./StudentBalance.vue?vue&type=template&id=bc221c50"
import script from "./StudentBalance.vue?vue&type=script&lang=ts"
export * from "./StudentBalance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports